import { render, staticRenderFns } from "./PatientRegister.vue?vue&type=template&id=58103719&scoped=true&"
import script from "./PatientRegister.vue?vue&type=script&lang=js&"
export * from "./PatientRegister.vue?vue&type=script&lang=js&"
import style0 from "./PatientRegister.vue?vue&type=style&index=0&id=58103719&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58103719",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1209661745/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58103719')) {
      api.createRecord('58103719', component.options)
    } else {
      api.reload('58103719', component.options)
    }
    module.hot.accept("./PatientRegister.vue?vue&type=template&id=58103719&scoped=true&", function () {
      api.rerender('58103719', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PatienBedFlow/PatientRegister.vue"
export default component.exports